import inspectorWorkload from "./inspectorWorkload";


const inspectorService = [
    {
        matcher: 'inspectors/workload',
        reply: config => {
            return [200, inspectorWorkload];
        }
    },
]

export default inspectorService;